import { useState } from "react";
import BackLink from "../../../shared/BackLink";
import { useDb } from "../../../../contexts/DatabaseContext";
import { useCollectionData } from "react-firebase-hooks/firestore";
import moment from "moment";
import { Button, Stack } from "@mui/material";
import RMFDataGrid from "../../../shared/data-grid/RMFDataGrid";
import RunManualDateBluElectricity from "./RunManualDateBluElectricity";

export default function BluElectricityReports() {
  const [manualOpen, setManualOpen] = useState(false);
  const { bluElectricityReportsCollection } = useDb();

  const [value, loading, error] = useCollectionData(
    bluElectricityReportsCollection
  );

  const rows =
    value &&
    value.map((row, index) => ({
      ...row,
      id: index,
      date: moment(row.created.toDate()).format("YYYY-MM-DD HH:mm"),
    }));

  const columns = [
    {
      field: "title",
      headerName: "File Name",
      width: 200,
      renderCell: (params) => {
        return (
          <Button
            href={params.row.url}
            target="_blank"
            rel="noopener noreferrer"
            variant="outlined"
            size="small"
          >
            {params.row.title}
          </Button>
        );
      },
    },
    { field: "date", headerName: "Report Date", width: 200 },
  ];

  return (
    <div>
      <h1>Blue Label Electricity Sales Report</h1>
      <BackLink />
      <Button
        color="primary"
        variant="contained"
        onClick={() => setManualOpen(true)}
      >
        Run Manual Date
      </Button>
      <br />
      <br />
      <Stack spacing={2}>
        {rows && <RMFDataGrid data={rows} columns={columns} />}
      </Stack>

      <RunManualDateBluElectricity
        open={manualOpen}
        close={() => setManualOpen(false)}
      />
    </div>
  );
}
